import params from '../../../setup/config/params'
import List from '../List'

const routes = {
  documents: {
    path: '/documents',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "utilities",
    subModule: "documentManager",
    action: "canView"
  }
}

export default routes
